import JikeLogo from '@/assets/jike-logo.svg?react'
import { openAppAuthConfirmationPage } from '@/utils/inAppAuth'
import { Box, Button, Stack } from '@mantine/core'
import { motion } from 'motion/react'
import loginSectionStyles from './LoginSection.module.css'

export interface MobileLoginSectionProps {
	redirectURL: string
}

export default function MobileLoginSection({ redirectURL }: MobileLoginSectionProps) {
	return (
		<motion.div layout className={loginSectionStyles.card}>
			<motion.div layout className={loginSectionStyles.content}>
				<Stack align="center" justify="center" gap="xl">
					<JikeLogo className={loginSectionStyles.logo} />

					<Stack gap="xl" align="center">
						<Box>通过即刻 App 授权登录</Box>
						<Button
							size="md"
							onClick={() => {
								openAppAuthConfirmationPage(redirectURL)
							}}
							w="fit-content"
						>
							去授权
						</Button>
					</Stack>
				</Stack>
			</motion.div>
		</motion.div>
	)
}
